export default __webpack_public_path__ + "static/media/wild.8489eeaf.png";